import { getApiActionTypes } from '../../../../shared/store/storeHelpers';

export const fetchTaxRatesTypes = getApiActionTypes('FETCH_TAX_RATES');
export const createTaxRateTypes = getApiActionTypes('CREATE_TAX_RATE');
export const updateTaxRateTypes = getApiActionTypes('UPDATE_TAX_RATE');
export const deleteTaxRateTypes = getApiActionTypes('DELETE_TAX_RATE');
